export default "__VITE_ASSET__cwiAcsci__"